export default "/_next/static/images/service-boarding-desktop-2x-3587e2f43b6c9960d25182bd2faad3d9.jpg";